import { createSelector } from 'reselect';

export default createSelector(
  state => state.employees,
  ({
    error,
    fulfilledTimeStamp,
    isError,
    isFetching,
    isLoading,
    isSuccess,
    isUninitialized,
    rehydrated,
    startedTimeStamp,
  }) => ({
    error,
    fulfilledTimeStamp,
    isError,
    isFetching,
    isLoading,
    isSuccess,
    isUninitialized,
    rehydrated,
    startedTimeStamp,
  }),
);
